import _ from "lodash";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";

import { api } from "@/APIRequests";
import { Footer } from "@/component-library/Footer";
import ChangePassword from "@/components/Authentication/ChangePassword";
import A5ScreeningDetails from "@/components/Common/A5ScreeningDetails";
import A5ScreeningList from "@/components/Common/A5ScreeningList";
import AVCheck from "@/components/Common/AVCheck";
import MessagesView from "@/components/Common/MessagesView";
import PrivacyPolicy from "@/components/Common/PrivacyPolicy";
import SystemCheck from "@/components/Common/SystemCheck";
import TutorialScreens from "@/components/Common/TutorialScreen";
import { WaitlistForm } from "@/components/Common/WaitlistForm/WaitlistForm";
import ActionSection from "@/components/Navigation/Toolbar/ActionSection/ActionSection";
import Toolbar from "@/components/Navigation/Toolbar/Toolbar";
import DraftNotesTable from "@/components/Provider/DraftNotes";
import { AdvancedCareActivityNewForm } from "@/components/Provider/PatientView/MemberProfile/AdvancedCareActivity/AdvancedCareActivityNewForm";
import CareCommunicationForm from "@/components/Provider/PatientView/MemberProfile/CareCommunication/CareCommunicationForm";
import { CareManagementNewForm } from "@/components/Provider/PatientView/MemberProfile/CareManagement/CareManagementNewForm";
import CaseManagementForm from "@/components/Provider/PatientView/MemberProfile/CaseManagement/CaseManagementForm";
import DischargeData from "@/components/Provider/PatientView/MemberProfile/DischargeData";
import MemberProfile from "@/components/Provider/PatientView/MemberProfile/MemberProfile";
import PrintNoteView from "@/components/Provider/PatientView/MemberProfile/PrintNoteView";
import AddAppointment from "@/components/Provider/ScheduleAvailability/AddAppointment";
import EditEvent from "@/components/Provider/ScheduleAvailability/EditEvent";
import GAD7 from "@/features/assessments/GAD7";
import PHQ9 from "@/features/assessments/PHQ9";
import { canCreateAdvancedCareActivityNotes } from "@/lib/helpers/checkACPNoteAccess";
import { getProviderProfile, isAuthorized } from "@/redux/actions/auth";
import { Main2 } from "@/ui2/atoms/Main";
import { redirectOnSignIn } from "@/utils/redirectOnSignIn";

import {
  provider_behavioral,
  provider_case_manager,
  provider_pcp,
  provider_peer,
  providerRoute,
} from "../../../config/roles";
import VideoClient from "../../VideoClient";
import mapLabelToComponent from "../common/mapLabelToComponent";
import Settings from "../common/SettingsPage";
import { ViewFullNote } from "../common/ViewFullNote/ViewFullNote";

import A5Report from "./A5Report";
import FileList from "./FileList";
import HomePage from "./HomePage";
import IBARReport from "./IBARReport";
import IPSRReport from "./IPSRReport";
import NewReport from "./NewReport";
import OBARReport from "./OBARReport";
import OnBehalfOfSchedule from "./OnBehalfOfSchedule";
import OPSRReport from "./OPSRReport";
import Patient from "./Patient";
import CareTeamList from "./PatientProfileView/CareTeamList";
import ClinicalAssessment from "./PatientProfileView/ClinicalAssessment";
import NewNote from "./PatientProfileView/NewNote";
import NewNoteV2 from "./PatientProfileView/NewNoteV2";
import ProgressNoteList from "./PatientProfileView/ProgressNoteList";
import Ratings from "./PatientProfileView/Ratings";
import ViewDraftNote from "./PatientProfileView/ViewDraftNote";
import ViewDraftNoteV2 from "./PatientProfileView/ViewDraftNoteV2";
import ViewNote from "./PatientProfileView/ViewNote";
import PatientsList from "./PatientsList";
import ProviderProfile from "./ProviderProfile";
import ReferralView from "./ReferralView";
import Reports from "./Reports";
// eslint-disable-next-line import-x/no-named-as-default
import SchedulePageV2 from "./SchedulePageV2";

class Provider extends Component {
  ROUTE_SECTION_OPTIONS = this.determineNavBarSelection();

  PROVIDER_BASE_REDIRECT_ROUTE =
    isAuthorized(provider_case_manager) || isAuthorized(provider_peer)
      ? `${providerRoute}/patient`
      : `${providerRoute}/home`;

  ACTION_SECTION_OPTIONS = [];

  RESTRICTED_FROM_PEER_AND_CASE_MANAGER = !(
    isAuthorized(provider_case_manager) || isAuthorized(provider_peer)
  );

  navbarConfiguration = {
    customRenderSection: [
      {
        componentProps: {
          config: {
            options: this.ACTION_SECTION_OPTIONS,
          },
        },
        isComponent: true,
        render: ActionSection,
      },
    ],
    routeSection: {
      options: this.ROUTE_SECTION_OPTIONS,
    },
    selfSection: {},
  };

  state = {
    totalUnreadMessages: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      totalUnreadMessages: 0,
    };
  }

  componentDidMount() {
    redirectOnSignIn(this.props.history);
    this.props.getProviderProfile();

    this.updateUnreadCount();

    if (process.env.REACT_APP_ENABLE_MESSAGE_NOTIFICATIONS_UPDATE === "true") {
      let time = process.env.REACT_APP_ENABLE_MESSAGE_NOTIFICATIONS_UPDATE_REFRESH_TIME;
      this.notification = setInterval(() => {
        if (document.hidden) {
          console.log("Document is currently hidden. Waiting to fetch unread message count.");
          return;
        }
        this.updateUnreadCount();
      }, parseInt(time));
    }
  }

  componentWillUnmount() {
    if (this.notification) {
      clearInterval(this.notification);
    }
  }

  determineNavBarSelection() {
    if (isAuthorized(provider_pcp)) {
      return [
        {
          activeIconComponent: mapLabelToComponent("Dashboard", true),
          icon: "NavMenu__dashboard-icon",
          iconComponent: mapLabelToComponent("Dashboard"),
          label: "Dashboard",
          mobileIcon: "dashboard.svg",
          route: this.props.url + "/home",
        },
        {
          activeIconComponent: mapLabelToComponent("Patients", true),
          icon: "NavMenu__patients-icon",
          iconComponent: mapLabelToComponent("Patients"),
          label: "Patients",
          mobileIcon: "patients.svg",
          route: this.props.url + "/patient",
        },
        {
          activeIconComponent: mapLabelToComponent("Patients", true),
          icon: "NavMenu__patients-icon",
          iconComponent: mapLabelToComponent("Patients"),
          label: "Add New Patient",
          mobileIcon: "add_new.svg",
          mobileOnly: true,
          route: this.props.url + "/patient/add",
        },
        {
          activeIconComponent: mapLabelToComponent("Reports", true),
          icon: "NavMenu__reports-icon",
          iconComponent: mapLabelToComponent("Reports"),
          label: "Reports",
          mobileIcon: "reports.svg",
          route: this.props.url + "/reports",
        },
        {
          activeIconComponent: mapLabelToComponent("Screening", true),
          icon: "NavMenu__screening-icon",
          iconComponent: mapLabelToComponent("Screening"),
          label: "Screening",
          mobileIcon: "screening.svg",
          route: this.props.url + "/a5_screenings",
        },
        {
          activeIconComponent: mapLabelToComponent("Settings", true),
          icon: "NavMenu__settings-icon",
          iconComponent: mapLabelToComponent("Settings"),
          label: "Settings",
          mobileIcon: "settings.svg",
          route: this.props.url + "/settings",
        },
      ];
    }

    if (isAuthorized(provider_case_manager) || isAuthorized(provider_peer)) {
      return [
        {
          activeIconComponent: mapLabelToComponent("Patients", true),
          icon: "NavMenu__patients-icon",
          iconComponent: mapLabelToComponent("Patients"),
          label: "Patients",
          mobileIcon: "patients.svg",
          route: this.props.url + "/patient",
        },
        {
          activeIconComponent: mapLabelToComponent("Reports", true),
          icon: "NavMenu__reports-icon",
          iconComponent: mapLabelToComponent("Reports"),
          label: "Reports",
          mobileIcon: "reports.svg",
          route: this.props.url + "/reports",
        },
        {
          activeIconComponent: mapLabelToComponent("Messages", true),
          iconComponent: mapLabelToComponent("Messages"),
          label: "Messages",
          route: this.props.url + "/messages",
        },
      ];
    }

    return [
      {
        activeIconComponent: mapLabelToComponent("Dashboard", true),
        icon: "NavMenu__dashboard-icon",
        iconComponent: mapLabelToComponent("Dashboard"),
        label: "Dashboard",
        mobileIcon: "dashboard.svg",
        route: this.props.url + "/home",
      },
      {
        activeIconComponent: mapLabelToComponent("Patients", true),
        icon: "NavMenu__patients-icon",
        iconComponent: mapLabelToComponent("Patients"),
        label: "Patients",
        mobileIcon: "patients.svg",
        route: this.props.url + "/patient",
      },
      {
        activeIconComponent: mapLabelToComponent("Reports", true),
        icon: "NavMenu__reports-icon",
        iconComponent: mapLabelToComponent("Reports"),
        label: "Reports",
        mobileIcon: "reports.svg",
        route: this.props.url + "/reports",
      },
      {
        activeIconComponent: mapLabelToComponent("Calendar", true),
        iconComponent: mapLabelToComponent("Calendar"),
        label: "Calendar",
        route: this.props.url + "/schedule",
      },
      {
        activeIconComponent: mapLabelToComponent("Messages", true),
        iconComponent: mapLabelToComponent("Messages"),
        label: "Messages",
        route: this.props.url + "/messages",
      },
    ];
  }

  async updateUnreadCount() {
    if (isAuthorized("provider:pcp")) {
      return;
    }

    const options = { params: { showLoader: false } };
    let count = await api.messaging.fetch_unread_message_count({ options });
    this.setState({
      totalUnreadMessages: count["unread_count"],
    });
  }

  render() {
    let baseUrl = this.props.url;
    let enableSearch = false;
    if (_.get(this.props, "profile.omnisearch_enabled")) {
      // eslint-disable-next-line unused-imports/no-unused-vars
      enableSearch = true;
      if (
        !this.navbarConfiguration.routeSection.options.some((option) => option.label === "Search")
      ) {
        this.navbarConfiguration.routeSection.options.push({
          activeIconComponent: mapLabelToComponent("Search", true),
          iconComponent: mapLabelToComponent("Search"),
          label: "Search",
        });
      }
      this.navbarConfiguration["customRenderSection"] = [
        {
          componentProps: {
            config: {
              options: this.ACTION_SECTION_OPTIONS,
            },
          },
          isComponent: true,
          render: ActionSection,
        },
      ];
    } else {
      this.navbarConfiguration["customRenderSection"] = [
        {
          componentProps: {
            config: {
              options: this.ACTION_SECTION_OPTIONS,
            },
          },
          isComponent: true,
          render: ActionSection,
        },
      ];
    }

    const showChangePassword = this.props.profile && !this.props.profile.idp;
    const providerType = this.props.profile?.provider_type;

    return (
      <>
        <Toolbar
          baseRoute={providerRoute}
          navbarConfiguration={this.navbarConfiguration}
          totalUnreadMessages={this.state.totalUnreadMessages}
        />

        <Main2>
          <Switch>
            {this.RESTRICTED_FROM_PEER_AND_CASE_MANAGER && (
              <Route
                path={baseUrl + "/home"}
                render={(props) => <HomePage {...props} {...this.props} />}
              />
            )}

            <Route component={Patient} path={baseUrl + "/patient/add"} />
            <Route component={NewNoteV2} path={baseUrl + "/patient/:patientId/note/add/v2"} />
            <Route component={NewNote} path={baseUrl + "/patient/:patientId/note/add"} />
            <Route
              component={ViewDraftNoteV2}
              path={baseUrl + "/patient/:patientId/note/:noteId/v2/draft"}
            />
            <Route
              component={ViewDraftNote}
              path={baseUrl + "/patient/:patientId/note/:noteId/draft"}
            />
            <Route
              component={ViewFullNote}
              path={baseUrl + "/patient/:patientId/note/:noteId/v2"}
            />
            <Route component={PrintNoteView} path={baseUrl + "/patient/:patientId/export_notes"} />
            <Route component={ViewNote} path={baseUrl + "/patient/:patientId/note/:noteId"} />
            <Route component={ProgressNoteList} path={baseUrl + "/patient/:patientId/note"} />

            {this.RESTRICTED_FROM_PEER_AND_CASE_MANAGER && (
              <Route
                component={CareCommunicationForm}
                path={baseUrl + "/patient/:patientId/care_communication"}
              />
            )}

            {this.RESTRICTED_FROM_PEER_AND_CASE_MANAGER && (
              <Route
                component={CaseManagementForm}
                path={baseUrl + "/patient/:patientId/case_management"}
              />
            )}

            {!isAuthorized(provider_peer) && (
              <Route
                component={CareManagementNewForm}
                path={baseUrl + "/patient/:patientId/care_management"}
              />
            )}

            {canCreateAdvancedCareActivityNotes(providerType) && (
              <Route
                component={AdvancedCareActivityNewForm}
                path={baseUrl + "/patient/:patientId/advanced_care_activity"}
              />
            )}
            <Route
              component={ClinicalAssessment}
              path={baseUrl + "/patient/:patientId/clinical_assessment"}
            />
            <Route component={MemberProfile} path={baseUrl + "/patient/:patientId/profile/v2"} />
            <Route component={CareTeamList} path={baseUrl + "/patient/:patientId/care_team"} />
            <Route component={IBARReport} path={baseUrl + "/patient/:patientId/report/ibar"} />
            <Route component={IPSRReport} path={baseUrl + "/patient/:patientId/report/ipsr"} />
            <Route component={OBARReport} path={baseUrl + "/patient/:patientId/report/obar"} />
            <Route component={OPSRReport} path={baseUrl + "/patient/:patientId/report/opsr"} />
            <Route component={A5Report} path={baseUrl + "/patient/:patientId/report/a5"} />
            <Route component={Reports} path={baseUrl + "/patient/:patientId/report"} />
            <Route component={Ratings} path={baseUrl + "/patient/:patientId/ratings"} />
            <Route component={PHQ9} path={baseUrl + "/patient/:patientId/phq-9"} />
            <Route component={GAD7} path={baseUrl + "/patient/:patientId/gad-7"} />
            <Route
              path={baseUrl + "/patient/:patientId/file"}
              render={(props) => <FileList {...props} type="patient" />}
            />
            <Route
              component={DischargeData}
              path={baseUrl + "/patient/:patientId/discharge/:dischargeId"}
            />

            {isAuthorized(provider_behavioral) && providerType === "BEHAVIORAL_INTAKE" && (
              <Route
                component={WaitlistForm}
                path={baseUrl + "/patient/:patientId/waitlist_form"}
              />
            )}
            <Route component={Patient} path={baseUrl + "/patient/:patientId"} />
            <Route component={PatientsList} path={baseUrl + "/patient"} />
            <Route component={ProviderProfile} path={baseUrl + "/profile"} />
            {this.RESTRICTED_FROM_PEER_AND_CASE_MANAGER && (
              <Route component={EditEvent} path={baseUrl + "/schedule/event"} />
            )}
            {this.RESTRICTED_FROM_PEER_AND_CASE_MANAGER && (
              <Route component={AddAppointment} path={baseUrl + "/schedule/add"} />
            )}
            {isAuthorized("provider:peer") || isAuthorized("provider:case_manager") ? (
              <Route
                path={baseUrl + "/schedule/:providerId"}
                render={(props) => <SchedulePageV2 {...props} />}
              />
            ) : (
              <Route component={OnBehalfOfSchedule} path={baseUrl + "/schedule/:providerId"} />
            )}
            {this.RESTRICTED_FROM_PEER_AND_CASE_MANAGER && (
              <Route
                path={baseUrl + "/schedule"}
                render={(props) => <SchedulePageV2 {...props} />}
              />
            )}
            {showChangePassword && (
              <Route
                path={baseUrl + "/change-password"}
                render={(props) => <ChangePassword {...props} baseRoute={providerRoute} />}
              />
            )}
            <Route
              path={baseUrl + "/settings"}
              render={() => <Settings baseRoute={providerRoute} />}
            />
            <Route
              path={baseUrl + "/privacy-policy"}
              render={() => <PrivacyPolicy baseRoute={providerRoute} />}
            />
            <Route
              path={baseUrl + "/tutorial"}
              render={() => <TutorialScreens baseRoute={providerRoute} />}
            />
            <Route component={SystemCheck} path={baseUrl + "/system-check"} />
            <Route component={AVCheck} path={baseUrl + "/av-check"} />
            <Route component={VideoClient} path={baseUrl + "/video-call"} />
            <Route component={NewReport} path={baseUrl + "/reports/add"} />
            <Route component={Reports} path={baseUrl + "/reports"} />
            {!isAuthorized("provider:pcp") && (
              <Route component={MessagesView} path={baseUrl + "/messages"} />
            )}
            {isAuthorized("provider:pcp") && (
              <Route
                path={baseUrl + "/a5_screenings/:screening_id/file"}
                render={(props) => <FileList {...props} type="a5_screenings" />}
              />
            )}
            {isAuthorized("provider:pcp") && (
              <Route
                component={A5ScreeningDetails}
                path={baseUrl + "/a5_screenings/:screening_id"}
              />
            )}
            {isAuthorized("provider:pcp") && (
              <Route component={A5ScreeningList} path={baseUrl + "/a5_screenings"} />
            )}
            <Route
              path={baseUrl + "/referral/:referralCode/file"}
              render={(props) => <FileList {...props} type="referral" />}
            />
            <Route component={ReferralView} path={baseUrl + "/referral/:referralCode"} />
            <Route component={DraftNotesTable} path={baseUrl + "/draft-notes"} />
            <Redirect from={baseUrl} to={this.PROVIDER_BASE_REDIRECT_ROUTE} />
          </Switch>
        </Main2>

        <Footer />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

Provider.propTypes = {
  getProviderProfile: PropTypes.func,
  history: PropTypes.object,
  profile: PropTypes.object,
  url: PropTypes.string,
};

export default connect(mapStateToProps, { getProviderProfile })(withRouter(Provider));
